<ng-template #showLoading>
    <acabim-loading-view></acabim-loading-view>
</ng-template>

<ng-container *ngIf="assetGroupForm && !loading else showLoading">
    <p-toast key="assetTypeNameMissing" position="top-center"></p-toast>
    <form [formGroup]="assetGroupForm" class="cas-form-floating">
        <acabim-form-block labelWidth="9" [labelAlign]="'right'" [colonize]="true">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Name</acabim-form-input-label>
                <acabim-form-input-content [shortField]="true">
                    <input type="text" formControlName="name" id="asset-type-name" placeholder="Enter an asset group name" />
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Description</acabim-form-input-label>
                <acabim-form-input-content [mediumField]="true">
                    <input type="text" formControlName="description" id="asset-type-description" placeholder="Enter an asset group description" />
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
        </acabim-form-block>
        <div class="cas-action-buttons cas-action-buttons-bottom">
            <button (click)="onCancel()">Cancel</button>
            <button class="cas-button-action cas-button-right" (click)="onSubmit()">Add</button>

        </div>
    </form>
</ng-container>
